{
  "name": "43edo (Sauveur 1696, dbbb-d###)",
  "description": "43-tone equal tempered scale consisting of 43 sonically equal divisions per octave. Similar to 1/5-Syntonic Comma Meantone, the system was described by Joseph Sauveur in 1696. Step-size (named méride by Sauveur) is 27.9 cents.",
  "scale": [
    "1\\43",
    "2\\43",
    "3\\43",
    "4\\43",
    "5\\43",
    "6\\43",
    "7\\43",
    "8\\43",
    "9\\43",
    "10\\43",
    "11\\43",
    "12\\43",
    "13\\43",
    "14\\43",
    "15\\43",
    "16\\43",
    "17\\43",
    "18\\43",
    "19\\43",
    "20\\43",
    "21\\43",
    "22\\43",
    "23\\43",
    "24\\43",
    "25\\43",
    "26\\43",
    "27\\43",
    "28\\43",
    "29\\43",
    "30\\43",
    "31\\43",
    "32\\43",
    "33\\43",
    "34\\43",
    "35\\43",
    "36\\43",
    "37\\43",
    "38\\43",
    "39\\43",
    "40\\43",
    "41\\43",
    "42\\43",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43edo",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "♭♭d",
    "♯♯b",
    "♯c",
    "♭d",
    "♭♭♭e",
    "♯♯c",
    "d",
    "♭♭e",
    "♯♯♯c",
    "♯d",
    "♭e",
    "♭♭f",
    "♯♯d",
    "e",
    "♭f",
    "♯♯♯d",
    "♯e",
    "f",
    "♭♭g",
    "♯♯e",
    "♯f",
    "♭g",
    "♭♭♭a",
    "♯♯f",
    "g",
    "♭♭a",
    "♯♯♯f",
    "♯g",
    "♭a",
    "♭♭♭b",
    "♯♯g",
    "a",
    "♭♭b",
    "♯♯♯g",
    "♯a",
    "♭b",
    "♭♭c",
    "♯♯a",
    "b",
    "♭c",
    "♭♭♭d",
    "♯b"
  ],
  "note_colors": [
    "#ff9d9d",
    "#ffe5e5",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#e4fbe6",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#cee3e2",
    "#dee2da"
  ],
  "equivSteps": 43,
  "fundamental": 440,
  "reference_degree": 32,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751
}
